export const MuiToggleButton = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      textTransform: 'none',
      color: '#000000C4',
      fontFamily: 'Avenir Next World',
      whiteSpace: 'nowrap',

      '&.Mui-selected': {
        color: '#1010EB',
        backgroundColor: '#140F4B1F',
      },
    },
  },
};
